module.exports = __webpack_public_path__ + "img/img44.38b6927a.jpg";